/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
import { defineSlotRecipe } from 'chakra-v3';

/**
 * Case Study Card Slot Recipe
 *
 * A multi-part component for displaying case study information with:
 * - Title (uppercase label)
 * - Divider (horizontal line)
 * - Description (main content)
 * - Footer (read more link with icon)
 *
 * Usage:
 * ```tsx
 * <CaseStudyCard
 *   title="SAMIKSHA"
 *   description="Assessment of generative models..."
 *   href="#"
 * />
 * ```
 */
export const caseStudyCardRecipe = defineSlotRecipe({
  slots: ['root', 'title', 'divider', 'description', 'footer', 'footerText'],
  base: {
    root: {
      bg: 'white',
      w: { base: '100%', lg: '304px' },
      h: { base: 'auto', lg: '341px' },
      position: 'relative',
      p: '23px',
      display: 'flex',
      flexDirection: 'column',
    },
    title: {
      fontSize: '13px',
      fontWeight: '500',
      color: 'bg.primary',
      fontFamily: 'body',
      letterSpacing: '1.3px',
      textTransform: 'uppercase',
      lineHeight: '1.406',
    },
    divider: {
      w: '85px',
      h: '1px',
      bg: 'bg.primary',
    },
    description: {
      fontSize: { base: '20px', md: '24px' },
      fontWeight: 'normal',
      color: 'bg.primary',
      fontFamily: 'heading',
      lineHeight: 'normal',
      letterSpacing: '-0.72px',
      flex: '1',
    },
    footer: {
      justifyContent: 'space-between',
      alignItems: 'center',
      mt: 'auto',
      pt: '20px',
      cursor: 'pointer',
      _hover: { opacity: 0.7 },
    },
    footerText: {
      fontSize: '20px',
      fontWeight: '300',
      color: 'bg.primary',
      fontFamily: 'body',
      lineHeight: '1.406',
    },
  },
});
